import request from '@/utils/request'
import JSEncrypt from 'jsencrypt'
let encryptor = new JSEncrypt()
// 公钥
let pushKey = "MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDiRp1J2on9XmD/3HpTIj4C9Ox4O4VQcodRQAtMLOaYc839h+9HJgtY6q9fPzpGpEJmIUo/NbBNel9rMlB6O15jINFCXHxiuubsA9yvqY0iIBkRh9kVdwixMyhFxlZ1RothAnd/jv1h2K364ccW9qQNUUKY+z/lSOoZzsUZirJWQQIDAQAB"
encryptor.setPublicKey(pushKey) // 设置公钥

export function reqUserInfo(data) {
  return request({
    url: '/web/user/sys/info',
    method: 'get',
    data
  })
}

export function sendMsg(data) {
  return request({
    url: '/laas/common/sendMsg',
    method: 'post',
    data:[encryptor.encrypt(JSON.stringify(data))],
    headers: {
      timestamp: Date.parse(new Date()),
    }
  })
}
export function reqGetArea(data) {//地区  省市区
  return request({
    url: '/web/common/getArea',
    method: 'get',
    data
  })
}
export function reqGetDict(params) {
  return request({
    url: '/web/common/getDict',
    method: 'get',
    params
  })
}
export function uploadFileAPI(data) {
  return request({
    url: '/laas/common/upload?type=1',
    method: 'post',
    data
  })
}

